import React from 'react';
import { checkmark_dark, checkmark } from '../../assets/animations/index';
import { Stack, Typography } from '@mui/material';
import { useLottie } from 'lottie-react';
import { useThemeContext } from '../../hook/useThemeManager';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { theme } from '../../constants/theme';

interface IEndOfDataMessage {
    messaage: string;
    showMoreClick?: () => void;
}
const EndOfDataMessage: React.FC<IEndOfDataMessage> = ({ messaage, showMoreClick }) => {
    const { darkModeEnabled, themeStyle } = useThemeContext();
    const options = {
        animationData: darkModeEnabled ? checkmark_dark : checkmark,
        loop: false,
    };
    const style = {
        height: '30px',
        width: '30px',
    };
    const { View } = useLottie(options, style);
    return (
        <Stack direction="row" alignItems="center" justifyContent="space-between">
            <Stack direction="row" alignItems="center">
                {View}
                <Typography
                    style={{
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 8,
                        color: theme[themeStyle].tag_white,
                        textAlign: 'left',
                    }}>
                    {messaage}
                </Typography>
            </Stack>
            <Typography
                onClick={showMoreClick}
                sx={{
                    fontFamily: FONT_ENUM.MAIN_BOLD,
                    fontSize: 8,
                    color: theme[themeStyle].main_blue,
                    cursor: 'pointer',
                    pr: 1,
                }}>
                Show older
            </Typography>
        </Stack>
    );
};

export { EndOfDataMessage };
